export * from "modules/KioskDashboard/components/DeleteKioskModal/hooks/useDeleteKioskMutation";
